import React from 'react';
import { PerformanceData } from '../types';
import { Panel } from '../components/UIComponents';
import { sqlViewStyles } from '../styles';

interface SqlViewProps {
  request: PerformanceData;
  selectedSqlId: number;
  onBack: () => void;
  onClose: () => void;
}

export const SqlView: React.FC<SqlViewProps> = ({ request, selectedSqlId, onBack, onClose }) => {
  if (!request.miniProfiler) return null;

  const { data } = request.miniProfiler;
  const selectedChild = data.root?.children?.[selectedSqlId || 0];
  const child = data.root?.children?.[0];
  const sqlDuration = child?.sql_timings_duration_milliseconds ?? data?.duration_milliseconds_in_sql ?? 0;

  if (!selectedChild) return null;

  return (
    <Panel
      title={`${(sqlDuration / 1000).toFixed(2)} s / ${request.name}`}
      onBack={onBack}
      onClose={onClose}
      fullScreen
    >
      <table style={sqlViewStyles.table}>
        <thead>
          <tr style={sqlViewStyles.tableHeader}>
            <th style={sqlViewStyles.tableHeaderCell}>class name</th>
            <th style={sqlViewStyles.tableHeaderCell}>query</th>
            <th style={sqlViewStyles.tableHeaderCell}>duration</th>
            <th style={sqlViewStyles.tableHeaderCell}>call stack</th>
          </tr>
        </thead>
        <tbody>
          {selectedChild.sql_timings?.map((sql: any, idx: number) => {
            const isEven = idx % 2 === 0;
            const isDuplicate = sql.is_duplicate;
            const isLongDuration = sql.duration_milliseconds > 5;

            return (
              <tr key={idx} style={sqlViewStyles.tableRow(isEven)}>
                <td style={sqlViewStyles.tableCell}>{sql.class_name}</td>
                <td style={sqlViewStyles.tableCell}>
                  <div style={sqlViewStyles.queryContainer(isDuplicate, isLongDuration)}>
                    {sql.formatted_command_string && (
                      <pre style={sqlViewStyles.queryPre}>
                        {sql.formatted_command_string.replace(/&quot;/g, '"').replace(/&#39;/g, "'")}
                      </pre>
                    )}
                  </div>
                </td>
                <td style={sqlViewStyles.tableCell}>{sql.duration_milliseconds?.toFixed(1)} ms</td>
                <td style={sqlViewStyles.tableCell}>
                  {sql.stack_trace_snippet && <div style={sqlViewStyles.stackTrace}>{sql.stack_trace_snippet}</div>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Panel>
  );
};
